<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis'
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  splitSentencesByDivider,
  splitCommaSeparatedWords,
} from '@/composables/splitSentence'
import PersonalPieChart from './PersonalPieChart.vue'
import PersonalityKeyword from './PersonalityKeyword.vue'
import PersonalityIlganBubble from './personalityIlganBubble.vue'

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
})
const store = useAnalysisStore()
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
})

const defaultPersonality = computed(() => splitBySentence(props.pData.개운방안.개념특징.개념))
const detailPersonality = computed(() => splitBySentence(props.pData.개운방안.개념특징.특징))
const strengthItems = computed(() =>
  splitCommaSeparatedWords(props.pData.개운방안.주요강점.강점요약),
)
const weaknessItems = computed(() =>
  splitCommaSeparatedWords(props.pData.개운방안.주요약점.약점요약),
)
const strengthDetail = computed(() => splitBySentence(props.pData.개운방안.주요강점.강점설명))
const weaknessDetail = computed(() => splitBySentence(props.pData.개운방안.주요약점.약점설명))
const strengthAdvice = computed(() => props.pData.개운방안.주요강점.강점추천)
const weaknessAdvice = computed(() => props.pData.개운방안.주요약점.약점추천)
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="detail-card__top-title personality">
          <span class="detail-tit__num personality">10</span>
          <span class="detail-tit__txt personality">나에게 에너지를 플러스 해주는 기운은?</span>
        </div>
        <div class="personality-wrapper">
          <div class="personality-divider" />
          <div class="person-content-box">
            <PersonalityKeyword
              :left-title="['에너지를 주는', '핵심 키워드 😊']"
              :keywords="props.pData.개운방안.개념특징.특징요약"
              :isMobile="isMobile"
            />
          </div>
          <div class="personality-divider" />

          <div class="person-content-box">
            <div class="content__title">🙌 이런 기운이 나와 잘 어울려요.</div>
            <div v-for="(sentence, idx) in defaultPersonality" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
          <div class="personality-divider" />
          <div class="person-content-box">
            <div class="content__title">🏃 이런 활동이 마음을 편안하게 해줘요.</div>
            <div v-for="(sentence, idx) in detailPersonality" :key="idx">
              <span class="content__body-txt">
                {{ sentence }}
              </span>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">💪 이 기운이 주는 긍정적인 힘</div>
            <div class="desc__body blue">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in strengthItems" :key="idx" class="keyword-item blue">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in strengthDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">에너지를 키워보세요. 😘</div>
                <div class="white-box__desc">
                  {{ strengthAdvice }}
                </div>
              </div>
            </div>
          </div>
          <div class="person-desc-box">
            <div class="desc__title">👀 놓치기 쉬운 부분일 수 있어요.</div>
            <div class="desc__body red">
              <div class="top-keyword">
                <div class="top-keyword__box">
                  <div v-for="(item, idx) in weaknessItems" :key="idx" class="keyword-item red">
                    {{ item }}
                  </div>
                </div>
                <div v-for="(str, idx) in weaknessDetail" :key="idx" class="top-keyword__desc">
                  {{ str }}
                </div>
              </div>
              <div class="bottom-white-box">
                <div class="white-box__tit">이런 방향도 좋아요. 😉</div>
                <div class="white-box__desc">
                  {{ weaknessAdvice }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
